import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["items"];

  connect() {
    this.params = JSON.parse(this.data.get("params"));
    Object.entries(this.params.custom_attributes).forEach((entry) =>
      this.add(entry)
    );
  }

  createFormGroup(label, value, container) {
    const formGroup = $("<div>")
      .addClass("form-group col-5 mb-0")
      .appendTo(container);

    $("<label>").text(label).appendTo(formGroup);

    const input = $("<input>")
      .addClass("form-control")
      .attr({
        type: "text",
      })
      .val(value)
      .appendTo(formGroup);

    return input;
  }

  refreshInputName(valueInput, name) {
    valueInput.attr(
      "name",
      name ? `${this.params.model_name}[custom_attributes][${name}]` : null
    );
  }

  add([key, value]) {
    const container = $("<div>").addClass("row mb-3");
    const keyInput = this.createFormGroup("Name", key, container);
    const valueInput = this.createFormGroup("Value", value, container);

    this.refreshInputName(valueInput, key);

    keyInput.on("change", (e) =>
      this.refreshInputName(valueInput, e.target.value)
    );

    const removeButton = $("<div>", {
      class: "btn btn-sm btn-primary mt-auto",
      html: '<i class="bi-trash"></i>',
    }).on("click", () => {
      container.remove();
    });

    $("<div>", { class: "col-2 d-flex pb-1" })
      .append(removeButton)
      .appendTo(container);

    container.appendTo(this.itemsTarget);
  }

  addClick() {
    this.add([null, null]);
  }
}
